import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiClock, FiLogOut } from 'react-icons/fi';
import { AuthContext } from '../auth/AuthContext';

const PendingApproval = () => {
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);

  const handleTryAgain = () => {
    logout();
    navigate('/');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #2C63AE 0%, #1272B3 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      fontFamily: "'Inter', sans-serif"
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 20,
        padding: '3rem 2.5rem',
        width: '100%',
        maxWidth: 420,
        boxShadow: '0 30px 80px rgba(0,0,0,0.35)',
        textAlign: 'center'
      }}>
        <div style={{
          width: 72,
          height: 72,
          background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 1.5rem'
        }}>
          <FiClock size={36} color="#b45309" />
        </div>

        <h1 style={{
          fontSize: '1.5rem',
          fontWeight: 800,
          color: '#b45309',
          marginBottom: '1rem'
        }}>
          Pending Approval
        </h1>

        <p style={{
          color: '#475569',
          fontSize: '1rem',
          lineHeight: 1.7,
          marginBottom: '1.5rem'
        }}>
          Your registration request has been submitted. An Admin or Manager will review and approve your account.
        </p>

        <p style={{
          color: '#64748b',
          fontSize: '0.9rem',
          lineHeight: 1.6,
          marginBottom: '2rem'
        }}>
          Once approved, you can log in again to access the dashboard.
        </p>

        {user?.email && (
          <div style={{
            background: '#f8fafc',
            borderRadius: 8,
            padding: '0.75rem 1rem',
            marginBottom: '1.5rem',
            fontSize: '0.875rem',
            color: '#475569'
          }}>
            Account: <strong>{user.email}</strong>
          </div>
        )}

        <button
          onClick={handleTryAgain}
          style={{
            width: '100%',
            padding: '0.875rem 1.5rem',
            background: '#1272B3',
            color: 'white',
            border: 'none',
            borderRadius: 10,
            fontWeight: 700,
            fontSize: '0.95rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem'
          }}
        >
          <FiLogOut size={16} />
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default PendingApproval;
